import {getWindow} from '#helpers/window'

export function getUser() {
  return JSON.parse(getWindow().localStorage.getItem('azg_user'))
}

export function setUser(user) {
  if (user) {
    getWindow().localStorage.setItem('azg_user', JSON.stringify(user))
  } else {
    getWindow().localStorage.removeItem('azg_user')
  }
}

export function getAccessToken() {
  const key = `oidc.user:${OIDC.authority}:${OIDC.clientId}`
  const value = getWindow().sessionStorage.getItem(key)
  return JSON.parse(value).access_token;
}

export function getTrackingDisabled() {
  const stringBoolean = getWindow().localStorage.getItem('trackingDisabled')
  if (stringBoolean != null) {
    return stringBoolean === 'true'
  }
  return false
}

export function hasNotSetTrackingPreference() {
  return getWindow().localStorage.getItem('trackingDisabled') === null
}

export function setTrackingDisabled(trackingDisabled) {
  getWindow().localStorage.setItem('trackingDisabled', trackingDisabled.toString())
}

export function getModuleSettings() {
  return JSON.parse(getWindow().sessionStorage.getItem('moduleSettings'))
}

export function setModuleSettings(moduleSettings) {
  if (moduleSettings) {
    getWindow().sessionStorage.setItem('moduleSettings', JSON.stringify(moduleSettings))
  } else {
    getWindow().sessionStorage.removeItem('moduleSettings')
  }
}

export function getAusbildungsplan(ausbildungsplanId) {
  if (ausbildungsplanId) {
    return JSON.parse(getWindow().sessionStorage.getItem(`ausbildungsplan:${ausbildungsplanId}`))
  }
  return JSON.parse(getWindow().sessionStorage.getItem('ausbildungsplan'))
}

export function setAusbildungsplan(ausbildungsplan, ausbildungsplanId) {
  if (ausbildungsplan) {
    setAusbildungsplanFromAusbildungsplan(ausbildungsplanId, ausbildungsplan)
  } else {
    getWindow().sessionStorage.removeItem('ausbildungsplan')
    removeAusbildungsplaeneWithAusbildungsplanId()
  }
}

const sessionStorageKey = 'qualifikationen'
export function getQualifications() {
  try {
    return JSON.parse(getWindow().sessionStorage.getItem(sessionStorageKey))
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e)
    getWindow().sessionStorage.removeItem(sessionStorageKey)
    return null
  }
}

export function setQualifications(qualifications) {
  getWindow().sessionStorage.setItem(sessionStorageKey, JSON.stringify(qualifications))
}

function removeAusbildungsplaeneWithAusbildungsplanId() {
  const sessionStorageKeys = Object.keys(getWindow().sessionStorage)
  const sessionStorageKeysToDelete = getSessionStotrageKeysForAusbildungsplaene(sessionStorageKeys)
  removeItemsFromSessionStorage(sessionStorageKeysToDelete)
}

function setAusbildungsplanFromAusbildungsplan(ausbildungsplanId, ausbildungsplan) {
  if (ausbildungsplanId) {
    getWindow().sessionStorage.setItem(`ausbildungsplan:${ausbildungsplanId}`, ausbildungsplan)
  } else {
    getWindow().sessionStorage.setItem('ausbildungsplan', ausbildungsplan)
  }
}

function removeItemsFromSessionStorage(sessionStorageToDelete) {
  let i
  for (i = 0; i < sessionStorageToDelete.length; i++) {
    getWindow().sessionStorage.removeItem(sessionStorageToDelete[i])
  }
}

function getSessionStotrageKeysForAusbildungsplaene(sessionStorageKeys) {
  const keys = []
  let j
  for (j = 0; j < sessionStorageKeys.length; j++) {
    if (sessionStorageKeys[j].substring(0, 16) === 'ausbildungsplan:') {
      keys.push(sessionStorageKeys[j])
    }
  }
  return keys
}
